import create from './create/model';
import view from './view/model';

export default {
    create,
    view,
};